import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND}/api`;

export const mediaUrl = (id, name) => `${API}/media/${id}/${name}`;

export function srcSet(img) {
  const vs = Array.isArray(img?.variants) ? img.variants : [];
  return vs.map((v) => `${mediaUrl(img.media_id, v.name)} ${v.width}w`).join(", ");
}

export function bestSrc(img, maxWidth = 1600) {
  const vs = Array.isArray(img?.variants) ? img.variants : [];
  const pick = vs.find((v) => v.width >= maxWidth) || vs[vs.length - 1];
  return pick ? mediaUrl(img.media_id, pick.name) : "";
}

export const adminApi = axios.create({ baseURL: API });
adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("jt_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !String(err.config?.url).includes("/auth/login")) {
      localStorage.removeItem("jt_admin_token");
      if (!window.location.pathname.startsWith("/admin/login")) window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}
